import { useSpreadSheetData } from '../SpreadSheetDataProvider'
import { setSorter } from '../SpreadSheetDataProvider/actions'
import { ChevronDown, ChevronUp } from 'react-feather'

HeaderSorter = ({ column }) ->

  [{ sorter }, dispatch] = useSpreadSheetData()

  Icon = sorter.ascending && ChevronDown || ChevronUp

  <>
    {if sorter.key is column.key
      <Icon
        style={{
          opacity: if sorter.key is column.key then 1 else 0
          width: 15
          top: 8
          position: 'relative'
          marginRight: 5
        }}
      />
    }
    <span
      style={{ cursor: unless column.relationConf then 's-resize' }}
      onClick={ ->
        unless column.relationConf
          dispatch(setSorter(column.key))
      }
    >{ column.label }</span>
  </>

export default HeaderSorter
